import { Accordion } from '@positivote/design-system/components/Accordion'
import { Div } from '@positivote/design-system/components/Div'
import { Divider } from '@positivote/design-system/components/Divider'
import { Loader } from '@positivote/design-system/components/Loader'
import { Typography } from '@positivote/design-system/components/Typography'

export interface AccordionRequirementsProps {
  requirementsProps: {
    title: string
    descriptions: Array<{
      key: string
      label: string
      value: number | string
      icon: React.ReactNode
      isLoading?: boolean
    }>
  }
  isLoading: boolean
}

export function AccordionRequirements({
  requirementsProps,
  isLoading
}: AccordionRequirementsProps): JSX.Element {
  return (
    <Accordion
      isOpen={true}
      Summary={<Typography variant="titleMedium">{requirementsProps.title}</Typography>}
      css={{
        borderRadius: '$lg',
        backgroundColor: '$surface-2',
        overflow: 'hidden',
        '& .Accordion-Details': {
          backgroundColor: '$background'
        }
      }}
    >
      <Divider />
      {requirementsProps.descriptions.map((description) => (
        <Div key={description.key} css={{ '&:last-child hr': { display: 'none' } }}>
          <Div
            css={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '$md $lg $md $3xl',
              alignItems: 'center'
            }}
          >
            <Div css={{ width: '100%' }}>
              <Typography
                variant="bodyMedium"
                css={{
                  color: '$on-surface-variant'
                }}
              >
                {description.label}
              </Typography>
            </Div>
            <Div css={{ width: '100%' }}>
              <Typography variant="titleSmall">{description.value}</Typography>
            </Div>

            <Div
              css={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              {description.isLoading ?? isLoading ? (
                <Loader size={20} strokeWidth={2} css={{ right: 2 }} />
              ) : (
                description.icon
              )}
            </Div>
          </Div>
          <Divider />
        </Div>
      ))}
    </Accordion>
  )
}
